import { environment } from '../environments/environment';

function isLoopbackHost(host: string): boolean {
  return host === 'localhost' || host === '127.0.0.1' || host === '[::1]';
}

function trimTrailingSlashes(value: string): string {
  let end = value.length;
  while (end > 0 && value.charAt(end - 1) === '/') {
    end -= 1;
  }
  return end === value.length ? value : value.slice(0, end);
}

function rewriteLoopbackHost(url: string, pageHost: string): string {
  try {
    const parsed = new URL(url);
    if (!isLoopbackHost(parsed.hostname)) {
      return url;
    }
    parsed.hostname = pageHost;
    return trimTrailingSlashes(parsed.toString());
  } catch {
    return url;
  }
}

/**
 * Sur mobile / LAN, la page est ouverte via l'IP du PC (ex. 192.168.1.x:4201)
 * mais environment pointe encore vers localhost:8081 — inutilisable depuis le téléphone.
 * On réécrit uniquement les hôtes loopback vers l'hôte de la page ; le port API reste.
 */
export function alignLocalApiHostWithPage(
  env: typeof environment = environment,
  pageHost: string = typeof window !== 'undefined' ? window.location.hostname : ''
): void {
  if (!pageHost || isLoopbackHost(pageHost)) {
    return;
  }

  env.apiUrl = rewriteLoopbackHost(env.apiUrl, pageHost);
  env.launcherApiUrl = rewriteLoopbackHost(env.launcherApiUrl, pageHost);
  env.otherAppUrl = rewriteLoopbackHost(env.otherAppUrl, pageHost);
}
